import { type Match, type MatchData, rounds } from "robotevents";

export const ELIMINATION_ROUNDS = [
	rounds.RoundOf16,
	rounds.Quarterfinals,
	rounds.Semifinals,
	rounds.Finals,
] as number[];

export function isMatchElimination(match: MatchData): boolean {
	return ELIMINATION_ROUNDS.includes(match.round);
}

export function isValidSKU(sku: string) {
	return !!sku.match(
		/RE-(VRC|V5RC|VEXU|VURC|VIQRC|VIQC|VAIRC|ADC)-[0-9]{2}-[0-9]{4}/g,
	);
}

export function isRestrictedSKU(sku: string) {
	return !!sku.match(/RE-(ADC)-[0-9]{2}-[0-9]{4}/g);
}

/**
 * Computes the next upcoming match from a list of matches. RobotEvents has a
 * bug where it will incorrectly report some matches are not started when they
 * have a zero score, even if they have been played. We can work around this by
 * checking for the next match in the list as well.
 *
 * @param matches List of matches in a single division (technically fieldset)
 * @returns The first unplayed match, or null if all matches have been played
 **/
export function getUpcomingMatch(matches: Match[]): Match | null {
	for (let i = 0; i < matches.length; i++) {
		const match = matches[i];

		if (match.started) {
			continue;
		}

		if (match.alliances.some((a) => a.score !== 0)) {
			continue;
		}

		const nextMatch = i < matches.length - 1 ? matches[i + 1] : null;
		if (!nextMatch) {
			return match;
		}

		if (!nextMatch.started && nextMatch.alliances.some((a) => a.score === 0)) {
			return match;
		}
	}

	return null;
}
